import { baseRequestWithHeaders } from './baseRequest';

export const viewCommentRequest = (requestId, type) => {
    const url = `/new-ops/comments/${requestId}/requests?t=${type}`;
    const method = 'GET';
    const data = {};
    return baseRequestWithHeaders(url, method, null, data);
};
